var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.00022 1.33264C11.6827 1.33264 14.6679 4.31787 14.6679 8.00034C14.6679 11.6828 11.6827 14.668 8.00022 14.668C4.31775 14.668 1.33252 11.6828 1.33252 8.00034C1.33252 4.31787 4.31775 1.33264 8.00022 1.33264ZM8.00022 2.33264C4.87004 2.33264 2.33252 4.87016 2.33252 8.00034C2.33252 11.1305 4.87004 13.668 8.00022 13.668C11.1304 13.668 13.6679 11.1305 13.6679 8.00034C13.6679 4.87016 11.1304 2.33264 8.00022 2.33264ZM7.99779 6.9997C8.25092 6.99953 8.46024 7.1875 8.49351 7.43153L8.49812 7.49937L8.50052 11.1671C8.5007 11.4432 8.27699 11.6672 8.00085 11.6674C7.74771 11.6676 7.5384 11.4796 7.50513 11.2356L7.50052 11.1678L7.49812 7.50002C7.49794 7.22388 7.72165 6.99988 7.99779 6.9997ZM8.00052 4.66785C8.36822 4.66785 8.66629 4.96593 8.66629 5.33363C8.66629 5.70133 8.36822 5.9994 8.00052 5.9994C7.63282 5.9994 7.33474 5.70133 7.33474 5.33363C7.33474 4.96593 7.63282 4.66785 8.00052 4.66785Z",
    fill: "#6E777C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoGray);
export default __webpack_public_path__ + "static/media/icon-info-gray.ceab85eb25ebe3ac08fc4a826286a930.svg";
export { ForwardRef as ReactComponent };